import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { listScrollGradient } from 'utils/styles.utils';

interface Props {
  children: ReactNode;
}

const StickyButtonContainer = ({ children }: Props) => {
  return (
    <Box
      sx={{
        mt: 3,
        position: 'sticky',
        bottom: 0,
        // Offset container
        mx: { xs: -2, md: 0 },
      }}
    >
      <Box
        sx={{
          bgcolor: 'background.default',
          borderTop: { xs: '1px solid', md: 'none' },
          borderColor: { xs: 'divider' },
          p: { xs: 2, md: 0 },
          pb: { xs: 4 },
          pt: { xs: 3 },
          ...listScrollGradient(),
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default StickyButtonContainer;
